import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-two-left-points-lined",
  "use": "rt-base-two-left-points-lined-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"rt-base-two-left-points-lined\"><defs><style type=\"text/css\"></style></defs><path d=\"M314 675c32 0 58 26 58 58s-26 58-58 58-58-26-58-58 26-58 58-58z m0-386c32 0 58 26 58 58s-26 58-58 58-58-26-58-58 26-58 58-58z\" p-id=\"10121\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/two-left-points-lined.svg
// module id = 1761
// module chunks = 228